import axios from "axios";

const BASE_URL = process.env.REACT_APP_ORDERS_SERVICE_BASE_URL;

export type AppType = "rider" | "driver";

export interface AppVersion {
  _id: string;
  app_type: AppType;
  play_store_version: string;
  app_store_version: string;
  huawei_store_version: string;
  created_at: string;
  updated_at: string;
}

export interface UpdateAppVersionDto {
  app_type: AppType;
  play_store_version?: string;
  app_store_version?: string;
  huawei_store_version?: string;
}

export interface AppVersionResponse {
  status: string | boolean;
  data: AppVersion;
}

export const appVersionService = {
  getLatestAppVersion: async (appType?: AppType): Promise<AppVersionResponse> => {
    const params = appType ? { app_type: appType } : {};
    const { data } = await axios.get<AppVersionResponse>(
      `${BASE_URL}/api/v1/app-versions/latest`,
      { params }
    );
    return data;
  },

  updateAppVersion: async (appVersionData: UpdateAppVersionDto): Promise<AppVersionResponse> => {
    const token = localStorage.getItem("token");
    const { data } = await axios.put<AppVersionResponse>(
      `${BASE_URL}/api/v1/app-versions`,
      appVersionData,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return data;
  },
};

